/** User-facing display name for an unnamed scratch derived from its Starter. */
export function scratchDisplayName(starterLabel: string): string {
  return `${starterLabel} scratch`;
}
